// import Test from './modules/Test'
import RelativeUrls from './modules/RelativeUrls'
import ScrollToSection from './modules/ScrollToSection'
// import AutoFitText from './modules/AutoFitText'
import ObjectFit from './modules/ObjectFit'
import FlickityPatch from './modules/patches/FlickityPatch'
import FlashMessage from './modules/forms/FlashMessage'
import Fields from './modules/forms/Fields'
// import SelectizePatch from './modules/patches/SelectizePatch'
import HideFieldsOnFormSuccess from './modules/forms/HideFieldsOnFormSuccess'
import Validation from './modules/forms/Validation'
import ViewHeigthFix from './modules/patches/ViewHeigthFix'
import JqueryEasings from './modules/patches/JqueryEasings'
import ImagesLoaded from './modules/ImagesLoaded'
import ResponsiveTable from './modules/ResponsiveTable'
import Select2SelectField from './modules/forms/Select2SelectField'
import Menu from './modules/Menu'
import 'bootstrap'
import NewsSlider from './modules/NewsSlider'
import SpecialismSlider from './modules/SpecialismSlider'
import Maps from './modules/Maps'

(() => {
    // Test()
    patch()
    forms()
    other()
})()

/**
 * Patch
 */
function patch() {
    // SelectizePatch()
    FlickityPatch()
    ViewHeigthFix()
    JqueryEasings()
}

/**
 * Forms
 */
function forms() {
    Fields()
    FlashMessage()
    HideFieldsOnFormSuccess()
    Validation()
}

/**
 * Other
 */
function other() {
    ImagesLoaded()
    // AutoFitText()
    ObjectFit()
    RelativeUrls()
    ScrollToSection()
    ResponsiveTable()
    Select2SelectField()
    Menu()
    NewsSlider()
    SpecialismSlider()
    Maps()
}
